import { useContext } from 'react';

import { ScheduleAppointmentContext } from '../index';

export const useScheduleAppointmentContext = () => {
  return useContext(ScheduleAppointmentContext);
};
